<template>
  <div class="VideoImgAndVideoFansAndComment">
      <div class="VideoImg">
        <!-- <img class="video-img" v-lazy="detailsList.furl" :alt="detailsList.objectname"> -->
      <div class="praise_bubble" id="praise_bubble">
      </div>
        <!-- 20201103增加暂停情况下和未开始一样处理 -->
        <!-- 开始、暂停、结束直播情况 -->
        <template v-if="this.detailsList.streamstatus !== 0 && this.detailsList.streamstatus !== 2">
          <template v-if="this.detailsList.streamstatus == 1">
            <div class="video-head" @click="satrtplay" v-show="videohead">
              <img class="video-img" v-lazy="detailsList.furl" :alt="detailsList.objectname">
              <img class="play" src="@/common/images/leveing/video/play.png" alt="播放" >
            </div>
          </template>
          <template v-else-if="this.detailsList.isossplay == 1 && (this.detailsList.streamstatus == 2 || this.detailsList.streamstatus == 10)">
            <div class="video-head" @click="satrtplay" v-show="videohead">
              <img class="video-img" v-lazy="detailsList.furl" :alt="detailsList.objectname">
              <img class="play" src="@/common/images/leveing/video/play.png" alt="播放" >
            </div>
          </template>
          <template v-else>
            <div class="video-head" v-show="videohead">
              <img class="video-img" v-lazy="detailsList.furl" :alt="detailsList.objectname">
            </div>
          </template>
          <videoPlay ref="video1"></videoPlay>
        </template>
        <!-- 未开始 暂停 直播情况 -->
        <template v-if="this.detailsList.streamstatus == 0 || this.detailsList.streamstatus == 2">
          <div class="video-head"  v-show="videohead">
            <img class="video-img" v-lazy="detailsList.furl" :alt="detailsList.objectname">
            <img v-if="detailsList.isopenpreview == 1" class="play" src="@/common/images/leveing/video/play.png" alt="播放" @click="previewPlay(detailsList.previewurl)">
          </div>
          <template v-if="detailsList.isopenpreview == 1">
              <!-- 预告片 -->
              <videoPlay ref="video2"></videoPlay>
          </template>
          <!-- 判断是否有预告片情况 -->
        </template>
        <img class="zan" src="@/common/images/leveing/video/zan.png" alt="点赞" @click="canvaslove">
        <div class="buyTipsBox" v-if="detailsList.feetype === 2 && !detailsList.isbuy && (detailsList.streamstatus !== 10 || detailsList.isossplay)">
            <div class="textTips">当前为付费直播，请购买后观看！</div>
            <div class="priceBtnBox">
              <div class="priceBox">
                  <div class="saleprice">￥{{detailsList.saleprice}}</div>
                  <div class="uprice" v-if="detailsList.uprice && Number(detailsList.uprice) > Number(detailsList.saleprice)">￥{{detailsList.uprice}}</div>
              </div>
              <div class="btn" @click="nowBuy">立即购买</div>
            </div>
        </div>
      </div>
      <!-- end 视频图片 -->
      <el-dialog title=" " :close-on-click-modal="false" :close-on-press-escape="false" class="chargeDialog" :visible.sync="chargeVisible" center width="388px">
          <p class="title">温馨提示</p>
          <p class="tips">当前为付费直播，请购买后观看！</p>
          <div class="price_box">
            <span class="saleprice">￥{{detailsList.saleprice}}</span>
            <span class="uprice" v-if="detailsList.uprice > detailsList.saleprice">￥{{detailsList.uprice}}</span>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="nowBuy">立即购买</el-button>
          </span>
      </el-dialog>
      <el-dialog title=" " :close-on-click-modal="false" :close-on-press-escape="false" class="passDialog" :visible.sync="passVisible" center width="388px">
          <p class="title">温馨提示</p>
          <p class="tips">当前为加密直播，请输入密码：</p>
          <el-input v-model="livepass" placeholder="请输入观看密码"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="checkLivepass">确认</el-button>
          </span>
      </el-dialog>
  </div>
  <!-- end 视频直播封面 and 视频直播点赞和评论 -->
</template>

<script>
import Vue from 'vue'
import infiniteScroll from 'vue-infinite-scroll'
import {addPraiseInfo, getAliveStatus} from 'api/pcvideo.js'
import {mapActions, mapGetters} from 'vuex'
import videoPlay from './video'
import 'vue-happy-scroll/docs/happy-scroll.css'
import {checkLiveEventPassword} from 'api/mLiveApi'

Vue.use(infiniteScroll)
export default {
  name: 'VideoImgAndVideoFansAndComment',
  props: ['detailsList'],
  data () {
    return {
      innerid: this.$route.query.innerid, // 编号
      loveStatus: false, // 点赞状态
      videohead: true, // 封面显示
      chargeVisible: false,
      passVisible: false,
      livepass: '',
      getLiveStatusTimer: null
    }
  },
  mounted () {
    this._intervalLeveingStatus()
  },
  methods: {
      // 确认输入密码
      checkLivepass() {
          if (this.livepass) {
              this.setLoading(true)
              checkLiveEventPassword({
                  data: {liveid: this.detailsList.objectid, livepass: this.livepass, channelid: this.$route.query.chid ? this.$route.query.chid : ''},
                  success: () => {
                      this.setLoading(false)
                      location.reload()
                      // console.log(res)
                  },
                  error: res => {
                      this.setLoading(false)
                      this.$message.error(res.msg)
                  }
              })
          } else {
              this.$message.error('请输入密码!')
          }
      },
      // 立即购买
      nowBuy() {
          if (this.user.isLogin) {
              this.$router.push({
                  name: 'OrderIndex',
                  query: {
                    kmctype: 3,
                  //   liveid: this.detailsList.objectid
                    kmcinnerid: this.detailsList.objectid,
                    chid: this.$route.query.chid ? this.$route.query.chid : ''
                  }
              })
          } else {
              this.setLoginPop(true)
          }
          // console.log('立即购买')
      },
      satrtplay() { // 播放视频
          if (this.detailsList.isbuy) {
              this.videohead = false
              // this.$refs.videoPlayer.player.play()
              if (this.detailsList.streamstatus == 1) {
                // 直播中
                this.$refs.video1.leveingPlay(this.detailsList.flvurl)
              } else if (this.detailsList.streamstatus == 2 || this.detailsList.streamstatus == 10) {
                  if(this.detailsList.ossurltype==1){
                    // 直播暂停或者结束
                    this.$refs.video1.leveingPlay(this.detailsList.ossurl)
                  } else {
                      //直接播放MP4文件
                    this.$refs.video1.playpreview(this.detailsList.ossurl)
                  }
              }
          } else {
              if (this.user.isLogin) {
                if (this.detailsList.feetype === 2) { // 去购买
                    this.chargeVisible = true
                } else if (this.detailsList.feetype === 3) {// 去输入密码
                    this.passVisible = true
                }
                // console.log('已登录')
              } else {
                  this.setLoginPop(true)
              }
          }
      },
      previewPlay(flvurl) { // 播放预告片
        this.videohead = false
        this.$refs.video2.playpreview(flvurl)
      },
      clickLoadingPopu() {  // 打开登录弹窗
        this.setLoginPop(true)
      },
      canvaslove() {  // 点赞动画
        if (this.user.isLogin == false) {
          this.setLoginPop(true)
          return
        }
        let praiseBubble = document.getElementById("praise_bubble");
        const b =Math.floor(Math.random() * 6) + 1;
        const bl =Math.floor(Math.random() * 11) + 1; // bl1~bl11
        let d = document.createElement("div");
        d.className = `bubble b${b} bl${bl}`;
        d.dataset.t = String(Date.now());
        praiseBubble.appendChild(d);
        // 点赞接口调试
        if (!this.loveStatus && this.detailsList.ispraise == 0) {
          this.setLoading(true)
          addPraiseInfo({
            data: {kmcinnerid: this.innerid, kmctype: 3, optype: 1},
            success: data => {
              this.setLoading(false)
              if (data.code == '000') {
                this.$message.success('点赞成功')

                // 点赞成功后关闭点赞
                this.loveStatus = true

                // 关闭评论轮询
                this._clearIntervalComment()

                this._getNewComment()
              } 
            },
            error: data => {
              this.setLoading(false)
              this.$message.error(data.msg)
            }
          })
        }
      },
      _intervalLeveingStatus() {  // 轮询直播状态
          // 定时轮询直播状态
            this.getLiveStatusTimer = setInterval(() => {
              this._getAliveStatus((data) => {
                  // 状态位发生变更
                  if (data.streamstatus !== this.detailsList.streamstatus) {
                    if (this.detailsList.isbuy) {
                        this.detailsList.streamstatus = data.streamstatus
                        this.detailsList.isossplay = data.isossplay
                        this.detailsList.flvurl = data.flvurl
                        this.detailsList.ossurl = data.ossurl
                        this.detailsList.ossurltype = data.ossurltype
                    }
                  }
                  if (data.streamstatus === 10 && this.getLiveStatusTimer) {
                      clearInterval(this.getLiveStatusTimer)
                  }
              })
            }, 20000)
          },
      _getAliveStatus(request) { // 获取直播状态
        getAliveStatus({
          data: {objectid: this.innerid},
          success: data => {
            request(data.data)
          },  
          error: data => {
            this.$message.error(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setLoginPop'])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters(['loginPop', 'user','domainInfo'])
  },
  components: {
    videoPlay
  }
}
</script>

<style lang="scss" type="text/scss" >
.VideoImgAndVideoFansAndComment {
    margin-bottom: 20px;
    height: 480px;
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;
    .mCSB_inside > .mCSB_container {
      margin-right: 0;
    }
    .video-head {
      position: absolute;
      z-index: 2;
      width: 860px;
      height: 480px;
    }
    .VideoImg {
      position: relative;
      width: 860px;
      height: 480px;
      display: block;
      .buyTipsBox {
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 338px;
        height: 76px;
        background: #fff;
        border-radius: 6px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
        z-index: 10;
        padding: 15px;
        box-sizing: border-box;
        .textTips {
          font-size: 14px;
          color: #333333;
          line-height: 20px;
        }
        .priceBtnBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .priceBox {
            display: flex;
            align-items: center;
            line-height: 20px;
            margin-bottom: 2px;
            .saleprice {
              font-size: 14px;
              color: #F56C6C;
              margin-right: 4px;
            }
            .uprice {
              font-size: 12px;
              color: #999999;
              text-decoration: line-through;
            }
          }
          .btn {
              width: 88px;
              height: 24px;
              background: #FF4747;
              color: #fff;
              font-size: 12px;
              border-radius: 15px;
              text-align: center;
              line-height: 24px;
              cursor: pointer;
          }
        }
      }
      .video-img {
        width: 100%;
        height: 100%;
        background: #ccc;
      }
      .zan,
      .play {
        position: absolute;
        cursor: pointer;
      }
      .play {
        margin: auto;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 70px;
        height: 70px;
      }
      .zan {
        z-index: 2;
        bottom: 25px;
        right: 10px;
        width: 56px;
        height: 56px;
      }
    }
    .chargeDialog, .passDialog {
        .el-dialog__header {
          padding: 0;
        }
        .el-dialog__headerbtn {
          top: 10px;
          right: 10px;
        }
        .el-dialog__body {
          padding-bottom: 10px;
          .title {
              font-size: 14px;
              font-weight: bold;
              line-height: 20px;
              margin-bottom: 10px;
          }
          .tips {
              font-size: 14px;
              margin-bottom: 10px;
          }
          .price_box {
              .saleprice {
                  font-size: 16px;
                  color: #FF4747;
              }
              .uprice {
                  margin-left: 6px;
                  color: #999999;
                  font-size: 14px;
              }
          }
        }
        .el-dialog__footer {
          .dialog-footer {
            .el-button--danger {
              background: #FF4747;
              width: 100px;
              height: 30px;
              padding: 0;
              line-height: 30px;
            }
          }
        }
    }
    .passDialog {
        .dialog-footer {
            .el-button {
              // background: #409EFF;
              width: 100px;
              height: 30px;
              padding: 0;
              line-height: 30px;
            }
        }
    }
}
</style>
<style lang="scss">
.VideoImgAndVideoFansAndComment {
  --bubble_time: 3s;
  --bubble_scale: 0.8s;
  .praise_bubble {
    width: 100px;
    height: 200px;
    position: absolute;
    z-index: 4;
    right: 20px;
    bottom: 100px;
    // background-color: #f4f4f4;
  }
  .bubble {
    position: absolute;
    width: 40px;
    height: 40px;
    left: 30px;
    bottom: 0px;
    background-repeat: no-repeat;
    background-size: 100%;
    transform-origin: bottom;
  }
  .b1 {
    background-image: url('./../../../../common/images/leveing/video/bg1.png');
    // 可以使用雪碧图
    // background-position: -42px -107px;
    // background-size: 188.5px 147px;
  }
  .b2 {
    background-image: url('./../../../../common/images/leveing/video/bg2.png');
    // background-position: -84px -107px;
    // background-size: 188.5px 147px;
  }
  .b3 {
    background-image: url('./../../../../common/images/leveing/video/bg3.png');
    // background-position: 0 -107px;
    // background-size: 188.5px 147px;
  }
  .b4 {
    background-image: url('./../../../../common/images/leveing/video/bg4.png');
    // background-position: -45px -62px;
    // background-size: 188.5px 147px;
  }
  .b5 {
    background-image: url('./../../../../common/images/leveing/video/bg5.png');
    // background-position: -107px -42px;
    // background-size: 188.5px 147px;
  }
  .b6 {
    background-image: url('./../../../../common/images/leveing/video/bg6.png');
    // background-position: -107px 0;
    // background-size: 188.5px 147px;
  }
  .bl1 {
    animation: bubble_1 var(--bubble_time) linear 1 forwards,
      bubble_big_1 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl2 {
    animation: bubble_2 var(--bubble_time) linear 1 forwards,
      bubble_big_2 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl3 {
    animation: bubble_3 var(--bubble_time) linear 1 forwards,
      bubble_big_1 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl4 {
    animation: bubble_4 var(--bubble_time) linear 1 forwards,
      bubble_big_2 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl5 {
    animation: bubble_5 var(--bubble_time) linear 1 forwards,
      bubble_big_1 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl6 {
    animation: bubble_6 var(--bubble_time) linear 1 forwards,
      bubble_big_3 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl7 {
    animation: bubble_7 var(--bubble_time) linear 1 forwards,
      bubble_big_1 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl8 {
    animation: bubble_8 var(--bubble_time) linear 1 forwards,
      bubble_big_3 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl9 {
    animation: bubble_9 var(--bubble_time) linear 1 forwards,
      bubble_big_2 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl10 {
    animation: bubble_10 var(--bubble_time) linear 1 forwards,
      bubble_big_1 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  .bl11 {
    animation: bubble_11 var(--bubble_time) linear 1 forwards,
      bubble_big_2 var(--bubble_scale) linear 1 forwards,
      bubble_y var(--bubble_time) linear 1 forwards;
  }
  @keyframes bubble_11 {
    0% {
    }
    25% {
      margin-left: -10px;
    }
    50% {
      margin-left: -10px;
    }
    100% {
      margin-left: -18px;
    }
  }
  @keyframes bubble_10 {
    0% {
    }
    25% {
      margin-left: -20px;
    }
    50% {
      margin-left: -20px;
    }
    100% {
      margin-left: -20px;
    }
  }
  @keyframes bubble_9 {
    0% {
    }
    25% {
      margin-left: 10px;
    }
    50% {
      margin-left: 10px;
    }
    100% {
      margin-left: 10px;
    }
  }
  @keyframes bubble_8 {
    0% {
    }
    25% {
      margin-left: 20px;
    }
    50% {
      margin-left: 20px;
    }
    100% {
      margin-left: 20px;
    }
  }
  @keyframes bubble_7 {
    0% {
    }
    25% {
      margin-left: 3px;
    }
    50% {
      margin-left: 1px;
    }
    75% {
      margin-left: 2px;
    }
    100% {
      margin-left: 3px;
    }
  }
  @keyframes bubble_6 {
    0% {
    }
    25% {
      margin-left: -3px;
    }
    50% {
      margin-left: -1px;
    }
    75% {
      margin-left: -2px;
    }
    100% {
      margin-left: -3px;
    }
  }
  @keyframes bubble_5 {
    0% {
    }
    25% {
      margin-left: 5px;
    }
    50% {
      margin-left: -5px;
    }
    75% {
      margin-left: -10px;
    }
    100% {
      margin-left: -20px;
    }
  }
  @keyframes bubble_4 {
    0% {
    }
    25% {
      margin-left: -5px;
    }
    50% {
      margin-left: -5px;
    }
    75% {
      margin-left: 20px;
    }
    100% {
      margin-left: 10px;
    }
  }
  @keyframes bubble_3 {
    0% {
    }
    25% {
      margin-left: -20px;
    }
    50% {
      margin-left: 10px;
    }
    75% {
      margin-left: 20px;
    }
    100% {
      margin-left: -10px;
    }
  }
  @keyframes bubble_2 {
    0% {
    }
    25% {
      margin-left: 20px;
    }
    50% {
      margin-left: 25px;
    }
    75% {
      margin-left: 10px;
    }
    100% {
      margin-left: 5px;
    }
  }
  @keyframes bubble_1 {
    0% {
    }
    25% {
      margin-left: -8px;
    }
    50% {
      margin-left: 8px;
    }
    75% {
      margin-left: -15px;
    }
    100% {
      margin-left: 15px;
    }
  }
  @keyframes bubble_big_1 {
    0% {
      transform: scale(0.3);
    }
    100% {
      transform: scale(1.2);
    }
  }
  @keyframes bubble_big_2 {
    0% {
      transform: scale(0.3);
    }
    100% {
      transform: scale(0.9);
    }
  }
  @keyframes bubble_big_3 {
    0% {
      transform: scale(0.3);
    }
    100% {
      transform: scale(0.6);
    }
  }
  @keyframes bubble_y {
    0% {
      margin-bottom: 0;
    }
    10% {
      margin-bottom: 0;
    }
    75% {
      opacity: 1;
    }
    100% {
      margin-bottom: 200px;
      opacity: 0;
    }
  }
}

</style>